module.exports = __webpack_public_path__ + "img/9c642c153573a97149dde1e0e4ceecda.b912ae5a.png";